import React from 'react';

const TimelineHeader = ({ days, dayWidth }) => {
  const getWeeks = () => {
    const weeks = [];
    let currentWeek = [];

    days.forEach((day, index) => {
      if (day.getDay() === 1 && currentWeek.length > 0) { // Monday
        weeks.push(currentWeek);
        currentWeek = [];
      }
      currentWeek.push(day);
      
      if (index === days.length - 1) {
        weeks.push(currentWeek);
      }
    });
    
    return weeks;
  };

  // Function to get ISO week number
  const getWeekNumber = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    // Get first day of year
    const yearStart = new Date(d.getFullYear(), 0, 1);
    // Calculate full weeks to nearest Thursday
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return weekNo;
  };

  return (
    <div style={{ width: days.length * dayWidth }}>
      {/* Week Headers */}
      <div className="relative border-b border-gray-200" style={{ height: '40px' }}>
        {getWeeks().map((week, weekIndex) => {
          const hasSunday = week.some(day => day.getDay() === 0);
          let weekStartIndex = 0;
          for (let i = 0; i < weekIndex; i++) {
            weekStartIndex += getWeeks()[i].length;
          }
          return (
            <div
              key={weekIndex}
              className={`absolute top-0 h-full text-xs font-medium text-center flex items-center justify-center ${
                hasSunday ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-600'
              }`}
              style={{
                left: weekStartIndex * dayWidth,
                width: week.length * dayWidth,
                borderRight: weekIndex < getWeeks().length - 1 ? '1px solid #e5e7eb' : 'none'
              }}
            >
              {week[0].toLocaleDateString('en-US', { month: 'long' })} - W{getWeekNumber(week[0])}
            </div>
          );
        })}
      </div>
      
      {/* Day Headers */}
      <div className="relative border-b border-gray-200" style={{ height: '60px' }}>
        {days.map((day, index) => {
          const isSunday = day.getDay() === 0;
          const today = new Date();
          const isToday = day.toDateString() === today.toDateString();
          return (
            <div
              key={index}
              className={`absolute top-0 h-full text-center flex flex-col justify-center ${
                isToday ? 'bg-blue-100' : isSunday ? 'bg-red-50' : 'bg-white'
              }`}
              style={{
                left: index * dayWidth,
                width: dayWidth,
                borderRight: index < days.length - 1 ? '1px solid #e5e7eb' : 'none'
              }}
            >
              <div className={`text-xs font-medium ${
                isToday ? 'text-blue-700' : isSunday ? 'text-red-700' : 'text-gray-900'
              }`}>
                {day.getDate()}
              </div>
              <div className={`text-xs ${
                isToday ? 'text-blue-600' : isSunday ? 'text-red-600' : 'text-gray-500'
              }`}>
                {new Date(day).toLocaleDateString('en-US', { weekday: 'short' })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(TimelineHeader);